import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Button from 'rebook/apps/base/components/Button';

import styles from './style.scss';


class BookTrialPlayerAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTrialText: true,
    };
  }

  hideTrialText() {
    const { showTrialText } = this.state;
    this.setState({ showTrialText: !showTrialText });
  }

  handleGAEvent() {
    this.hideTrialText();
    ga('send', 'event', {
      eventCategory: 'AudioBook',
      eventAction: 'PressButton',
      eventLabel: 'GoToPaywall',
    });
  }

  render() {
    const { paymentLink, user } = this.props;
    const { showTrialText } = this.state;

    return (
      <div className={classNames(
        styles.trialPlayerAlert,
        styles.trialPlayerAlertNoRent,
        !showTrialText && styles.trialPlayerAlertHidden,
        'cy-trialplayer-alert-non-rent'
      )}>
        <div onClick={() => this.hideTrialText()}
          className={classNames(
            styles.toggleButton,
            showTrialText ? 'open' : 'close',
            'jest-hide-trial-player-text-button-non-rent'
          )} />
        {showTrialText && (
          <React.Fragment>
            <div className={styles.trialPlayerAlertContainer}>
              <span className={styles.trialPlayerAlertHeader}>Пробный фрагмент</span>
              <span className={styles.trialPlayerAlertTitle}>
                Чтобы слушать полную версию этой аудиокниги, оформите подписку.
                При оформлении подписки первые 14&nbsp;дней вы
                сможете слушать бесплатно.&nbsp;
                {!user && (
                  <React.Fragment>
                    Если у&nbsp;вас уже есть подписка,&nbsp;
                    <Link onClick={() => this.hideTrialText()}
                      className={classNames(styles.linkToLogin, 'link')} to="/account/login/">
                      войдите на сайт
                    </Link>
                    &nbsp;под вашей учётной записью.
                  </React.Fragment>
                )}
              </span>
            </div>
            <Button handleClick={() => { this.handleGAEvent(); }}
              link={paymentLink}
              extraClassName={classNames(styles.trialPlayerAlertButton, 'jest-link-to-rent-audiobook')}
              size="small"
              theme="primary">
              <span>Слушать полную версию</span>
            </Button>
          </React.Fragment>
        )}
        {!showTrialText && (
          <div className={styles.shortTitleContainer}>
            <span className={styles.hiddenHeader}>Пробный фрагмент</span>
          </div>
        )}
      </div>
    );
  }
};

export default BookTrialPlayerAlert;
